import React, {
  useEffect,
  useState,
  useRef
} from 'react';
import PropTypes from 'prop-types';
import {
  documentDelete,
  fetchDoc,
  singleDocFetchState,
  useShowToast
} from '../../recoil';
import {
  useRecoilState,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil';
import { DeleteIcon, Download, PdfIcon, CloseIcon } from '../../assets';
import { formatBytes } from '../../helpers';
import { useFindErrorOnState } from '../../hooks/useFindErrorOnState';
import './DocumentCard.css';
import { ConfirmModal } from '../PopupModal/PopupModal';

export const DocumentCard = ({ docName, docId, docSize, setIsDocumentUploaded, setUploadPercentage }) => {

  const deleteFile = useSetRecoilState(documentDelete);
  const [file, fetchFile] = useRecoilState(fetchDoc);
  const showToast = useShowToast();
  const iconType = 'info';
  const timeout = 'long';
  const isFileDownloadComplete = useRef(false);
  const resetFetchedDoc = useResetRecoilState(singleDocFetchState);
  const [isOpenDocDelete, setOpenDocDelete] = useState(false);

  useFindErrorOnState([fetchDoc], () => {
    resetFetchedDoc();
  });

  useEffect(() => {
    if (file?.error) {
      fetchFile(null);
      return;
    }
    if (file?.blobFile && file?.fileName && !isFileDownloadComplete.current) {

      isFileDownloadComplete.current = true;
      const anchor = document.createElement('a');
      anchor.style.display = 'none';
      anchor.href = file.blobFile;
      anchor.setAttribute('download', file.fileName);
      anchor.click();
      try {
        if (anchor.parentNode) {
          anchor.parentNode.removeChild(anchor);
        } else {
          anchor.remove();
        }
      } catch {
        fetchFile(null);
      }
      fetchFile(null);
    }
  }, [file]);

  const deleteDocument = () => {
    deleteFile(docId);
    showToast(
      'Bank statement deleted successfully.',
      iconType,
      timeout,
      '',
      true
    );
    setIsDocumentUploaded(false);
    setUploadPercentage(0);
  };

  const openDeletePopup = () => {
    setOpenDocDelete(true);
  };

  const downloadFile = async () => {
    isFileDownloadComplete.current = false;
    fetchFile(docId);
  };

  return (
    <>
      {isOpenDocDelete && (
        <ConfirmModal
          closeCallback={() => setOpenDocDelete(false)}
          icon={CloseIcon}
          title={'Are you sure?'}
          subTitle={'You are about to delete your bank statements'}
          acceptLabel={'Delete bank statements'}
          cancelLabel={'Cancel'}
          onAcceptClick={deleteDocument}
        />
      )}
      <div className="documentCard">
        <div className="documentLeftSection">
          <img
            src={PdfIcon}
            alt="PDF Icon"
            className="fileImg"
          />
          <div className="documentContainer">
            <div className="documentLabel">Proof of banking</div>
            <div className="documentName">
              {docName}
            </div>
          </div>
          <div className="documentSize">{formatBytes(docSize)}</div>
        </div>

        <div className="documentRightSection">
          <div
            className="iconGroup"
            role='presentation'
            onClick={downloadFile}
            onKeyDown={downloadFile}
          >
            <img
              src={Download}
              alt="Download Icon"
              className="downloadImg"
            />
            {<div>Download</div>}
          </div>
          <div
            className="iconGroup"
            role='presentation'
            onClick={() => openDeletePopup()}
            onKeyDown={() => openDeletePopup()}
          >
            <img
              src={DeleteIcon}
              alt="Delete Icon"
              className="removeImg"

            />
            {<div>Delete</div>}
          </div>
        </div>
      </div>
    </>
  );
};

DocumentCard.propTypes = {
  docName: PropTypes.string.isRequired,
  docId: PropTypes.string,
  docSize: PropTypes.number,
  setIsDocumentUploaded: PropTypes.func,
  setUploadPercentage: PropTypes.func
};
